import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=77f167ad"
import script from "./Popular.vue?vue&type=script&lang=js"
export * from "./Popular.vue?vue&type=script&lang=js"
import style0 from "./Popular.vue?vue&type=style&index=0&id=77f167ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports